import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button"]

    connect() {
        this.openWhenReady = false
        this.findWidgetButton = this.findWidgetButton.bind(this)
        this.syncExpandedState = this.syncExpandedState.bind(this)

        this.widgetObserver = new MutationObserver(this.findWidgetButton)
        this.widgetObserver.observe(document.body, { childList: true, subtree: true })
        this.findWidgetButton()
    }

    disconnect() {
        this.widgetObserver?.disconnect()
        this.expandedObserver?.disconnect()

        if (this.widgetButton) {
            this.widgetButton.style.removeProperty("display")
        }
    }

    open(event) {
        event.preventDefault()

        if (this.widgetButton?.isConnected) {
            this.widgetButton.click()
            this.syncExpandedState()
            return
        }

        this.openWhenReady = true
        this.buttonTargets.forEach((button) => button.setAttribute("aria-busy", "true"))
        this.findWidgetButton()
    }

    findWidgetButton() {
        const widgetButton = document.querySelector(".asw-container .asw-menu-btn")
        if (!widgetButton || widgetButton === this.widgetButton) return

        this.widgetButton = widgetButton
        this.widgetButton.style.setProperty("display", "none", "important")

        this.expandedObserver?.disconnect()
        this.expandedObserver = new MutationObserver(this.syncExpandedState)
        this.expandedObserver.observe(this.widgetButton, {
            attributes: true,
            attributeFilter: ["aria-expanded"]
        })

        this.syncExpandedState()
        this.widgetObserver.disconnect()

        if (this.openWhenReady) {
            this.openWhenReady = false
            this.widgetButton.click()
            this.syncExpandedState()
        }
    }

    syncExpandedState() {
        const expanded = this.widgetButton?.getAttribute("aria-expanded") || "false"
        this.buttonTargets.forEach((button) => {
            button.setAttribute("aria-expanded", expanded)
            button.removeAttribute("aria-busy")
        })
    }
}
